import { IUser as User } from 'models/User';

export const isInRole = (role: string) => {
    const user = getUser();
    if (user != null) return user.roles.includes(role);
    return false;
};

export const getAccessToken = (): string => {
    const user = getUser();
    if (user == null) return '';
    return user.token;
};

export const getUser = (): User | null => {
    const userStr = localStorage.getItem("user");
    if (userStr) return JSON.parse(userStr);
    return null;
};